import { Routes } from '@angular/router'

import { IsUserAllowedGuard } from '../guards'
import { PAGES } from '../shell/nav'
import { ReactAppComponent } from './react-app.component'

/**
 * Angular routes whose screen is actually rendered by the React app (/v2) in an iframe.
 *
 * Each path here mirrors a route declared in react/src/App.tsx — the iframe src is derived
 * from the Angular URL (see utils/embed-url.ts), so a missing entry means a hard refresh or a
 * bookmark on that screen climbs back to the Angular home page.
 *
 * Adding a React screen: add the route to react/src/App.tsx, then here (and to PAGES in
 * src/app/shell/nav.ts if it belongs in the sidebar).
 *
 * Keep this array declarative: Angular 5's AOT metadata collector only evaluates literals and
 * references to exported symbols, so no helper functions, loops or spreads of local values.
 */
export const REACT_APP_ROUTES: Routes = [
  {
    path: PAGES.replies.path,
    component: ReactAppComponent,
    canActivate: [ IsUserAllowedGuard ],
    data: PAGES.replies.data
  },

  {
    path: PAGES.invoices.path,
    component: ReactAppComponent,
    canActivate: [ IsUserAllowedGuard ],
    data: PAGES.invoices.data
  },
  {
    path: 'invoices/:id',
    component: ReactAppComponent,
    canActivate: [ IsUserAllowedGuard ],
    data: PAGES.invoices.data
  },

  {
    path: PAGES.documents.path,
    component: ReactAppComponent,
    canActivate: [ IsUserAllowedGuard ],
    data: PAGES.documents.data
  },
  {
    path: 'documents/:id/editor',
    component: ReactAppComponent,
    canActivate: [ IsUserAllowedGuard ],
    data: PAGES.documents.data
  },
  {
    path: 'documents/:id/instances',
    component: ReactAppComponent,
    canActivate: [ IsUserAllowedGuard ],
    data: PAGES.documents.data
  },
  {
    path: 'documents/:id/instances/:instanceId/fill',
    component: ReactAppComponent,
    canActivate: [ IsUserAllowedGuard ],
    data: PAGES.documents.data
  }
]
